import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComputPage from '@/components/ComputePage.vue';
import ComputeWizardQuality from '@/components/ComputeWizard/ComputeWizardQuality.vue';
import { RoutePath } from '@/enums/Router';

export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeQualityPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputPage, {
    class: "compute-quality-page",
    "prev-url": _unref(RoutePath).COMPUTE_STEP_FRICTION,
    "next-url": _unref(RoutePath).COMPUTE_STEP_CLAMPING,
    title: _ctx.$t('home.steps.quality.label'),
    "current-step": 4
  }, {
    default: _withCtx(() => [
      _createVNode(ComputeWizardQuality)
    ]),
    _: 1
  }, 8, ["prev-url", "next-url", "title"]))
}
}

})